<template>
  <div class="rolement vue_flex vue_flex_between app-container ">
    <div class="rolement-person vue_flex vue_column vue_align_center">
      <div class="rolement-person-inp vue_flex vue_align_center">
        <img class="top_bar_inp_img1" src="../../../../../assets/yimou/ss.png" alt="" />
        <input type="text" class="vue_flex_item" v-model="searchValue" placeholder="搜索角色" />
      </div>

      <div class="rolement-person-data">
        <div class="rolement-person-data-boxs vue_flex vue_align_center vue_flex_between" :class="Number(personIndex) === Number(itemIndex)? 'active' : ''" v-for="(item, itemIndex) in personList" :key="itemIndex" @click="personClick(itemIndex)">
          <div class="vue_flex vue_align_center">
            <img src="../../../../../assets/yimou/rytb.png" alt="">
            <p class="vue-font-PingFang-500 color_35">{{item.desc || ''}}</p>
          </div>
          <el-dropdown>
            <el-button type="text">编辑</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item type="success" size="mini">
                <el-button type="text" @click="exportExcel('edit', item)">重命名</el-button>
              </el-dropdown-item>
              <div class="dropdown-solid"></div>
              <el-dropdown-item type="success" size="mini">
                <el-button type="text" @click="exportExcel('del', item)">删除</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="rolement-person-but vue-font-PingFang-500 color_255" @click="exportExcel('add')">添加角色</div>
    </div>

    <div class="rolement-right vue_flex_item vue_flex vue_column">
      <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
        <ul class="plateorder-tabs-boxs vue_flex">
          <li class="vue_relative h" :class="activeName === tabs.activeVal? 'active' : 'activenot'" v-for="(tabs, tabsIndex) in tabsList" :key="tabsIndex" @click="handleClick(tabs)">
            <p class="vue-font-PingFang-bold">{{tabs.title}}</p>
            <div class="vue_absolute" v-if="activeName === tabs.activeVal"></div>
          </li>
        </ul>

        <template v-if="activeName === 'journa'">
          <div class="plateorder-tabs-input-but vue-font-PingFang-500 color_255" v-if="!disabledState" @click="disabledState = true">编辑权限</div>
          <div class="plateorder-tabs-input-but vue-font-PingFang-500 color_255" v-if="disabledState" @click="disabledState = false">保存</div>
        </template>
      </div>

      <div class="width_100" v-if="activeName === 'partper'">
        <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border :key="'partperTable'">
          <el-table-column prop="nickname" label="用户昵称" align="center"></el-table-column>
          <el-table-column prop="account" label="登录账号" align="center"></el-table-column>
          <el-table-column prop="role" label="角色" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isadmin === '1'">主账号</el-tag>
              {{scope.row.roles_name || ''}}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="账号状态" align="center" >
            <template slot-scope="scope">
              <div class="vue_flex vue_flex_around">
                <div class="vue_flex vue_align_center">
                  <div :class="scope.row.accountstatus === '1'? 'statusactnot' : 'statusact'"></div>
                  <span>{{scope.row.accountstatus === '1'? '禁止' : '正常'}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getindexUserFun"/>
      </div>

      <div class="journa-ability width_100" v-if="activeName === 'journa' || activeName === 'ability'">
        <div class="rolement-title vue_flex vue_align_center">
          <img src="../../../../../assets/yimou/gth.png" alt="">
          <p class="vue-font-PingFang-500 color_35">默认可査看，指该模块下当前及未来新增的所有内容均可查看</p>
        </div>
        <el-table :data="dataList" row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" style="width: 100%" :header-cell-style="headercellstyle" border :key="'journaTable'">
          <el-table-column prop="categor" label="报表分类" align="center">
            <template slot-scope="scope">
              <div class="vue_flex vue_flex_around">
                <div class="vue_flex vue_align_center">
                  <img src="../../../../../assets/yimou/wjj.png" alt="" v-if="scope.row.level === 1" style="width: 29px; height: 27px; margin-right: 14px;">
                  <img src="../../../../../assets/yimou/jg.png" alt="" v-if="scope.row.level === 2" style="width: 27px; height: 29px; margin-right: 14px;">
                  <span>{{scope.row.name}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="permiss" label="查看权限" align="center">
            <template slot-scope="scope">
              <input type="checkbox" :disabled="!disabledState" v-model="scope.row.checked">
              <span style="margin-left: 13px">{{scope.row.permiss}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog 
      @close="importClose" 
      :visible.sync="dialogimportVisible" 
      custom-class="unique-dialog" 
      width="752px" 
      :close-on-click-modal="false" 
      :show-close="false"
      :before-open="beforeDialogOpen"
    >
      <div class="import-mask vue_flex vue_align_center vue_column">
        <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">{{dialogType === 'edit'? '编辑角色' : '添加角色'}}
          <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute" @click="dialogimportVisible = false">
        </div>
        <div class="import-mask-boxs vue_flex vue_column">
          <div class="import-mask-boxs-inp">
            <ul class="vue_flex vue_align_center">
              <li class="vue_flex vue-font-PingFang-500">
                <span>*</span>
                <p class="color_35"> 角色 </p>
              </li>
              <li class="import-mask-ul-boxs">
                <el-input v-model="rolesObj.roles" placeholder="请输入"></el-input>
              </li>
            </ul>
            <ul class="vue_flex vue_align_center">
              <li class="vue_flex vue-font-PingFang-500">
                <span>*</span>
                <p class="color_35"> 菜单 </p>
              </li>
              <li class="import-mask-ul-boxs">
                <!-- 核心：永久关闭原生联动，添加手动联动的check事件 -->
                <el-tree 
                  v-if="dialogimportVisible && routesData.length > 0"
                  ref="tree" 
                  :check-strictly="true" 
                  :data="routesData" 
                  :props="defaultProps" 
                  :show-checkbox="true" 
                  node-key="id" 
                  class="permission-tree"
                  @check="handleTreeCheck"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="import-mask-but vue-font-PingFang-500 color_255" @click="confirmRole">确认</div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialoguserVisible" custom-class="unique-dialog" width="1100px" :close-on-click-modal="false" :show-close="false">
      <div class="import-mask import-maskuser vue_flex vue_align_center vue_column">
        <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">添加用户
          <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute" @click="dialoguserVisible = false">
        </div>

        <div class="import-maskuser-boxs vue_flex vue_flex_between width_100" style="">
          <div class="import-maskuser-boxs-div vue_flex vue_column">
            <div class="rolement-person-inp vue_flex vue_align_center">
              <img class="top_bar_inp_img1" src="../../../../../assets/yimou/ss.png" alt="" />
              <input type="text" class="vue_flex_item" v-model="searchValue" placeholder="搜索角色" />
            </div>
            <p class="import-maskuser-boxs-div-title vue-font-PingFang-500 color_35">用户</p>
            <div class="import-maskuser-boxs-div-user vue_flex vue_align_center">
              <input type="checkbox" v-model="userchecked" @change="allchecked">
              <p class="vue-font-PingFang-500 color_35">全部</p>
            </div>
            <div class="import-maskuser-boxs-div-scroll">
              <div v-for="(user, userIndex) in userList" :key="userIndex" class="import-maskuser-boxs-div-user vue_flex vue_align_center">
                <input type="checkbox" v-model="user.checked" @change="checkedClick(user)">
                <p class="vue-font-PingFang-500 color_35">{{user.title}}</p>
              </div>
            </div>
          </div>
          <div class="import-maskuser-boxs-solid"></div>
          <div class="import-maskuser-boxs-div vue_flex vue_column">
            <div class="import-maskuser-boxs-div-content vue_flex vue_flex_between vue_align_center">
              <p class="vue-font-PingFang-500 color_35">已选择</p>
              <p class="vue-font-PingFang-bold">清空</p>
            </div>
            <div class="import-maskuser-boxs-right-scroll">

            </div>
            <div class="vue_flex vue_flex_end">
              <div class="import-maskuser-boxs-but vue-font-PingFang-500 color_255">确认</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
import path from 'path'

export default {
  components: { Pagination },
  data() {
    return {
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: 'rgba(245, 247, 250, 1)',
        color: 'rgba(51, 3, 0, 1)'
      },

      searchValue: '',
      personIndex: 0,
      personList: [],

      dialogimportVisible: false,
      input: '',

      activeName: 'partper',
      tabsList: [{title: '成员', activeVal: 'partper'},],
      // tabsList: [{title: '成员', activeVal: 'partper'}, {title: '报表查看权限', activeVal: 'journa'}],

      dataList: [],

      total: 0,
      listQuery: {
        page: 1,
        limt: 10
      },

      partperList: [],
      journaList:[{
        id: 1,
        categor: '决策',
        permiss: '默认可查看',
        level: 1,
        checked: false,
        children: [{
          id: 1.1,
          categor: '核心指标速览',
          permiss: '查看',
          level: 2,
          checked: false,
        }, {
          id: 1.2,
          categor: '实时看板',
          permiss: '查看',
          level: 2,
          checked: false,
        }, {
          id: 1.3,
          categor: '经营目标追踪',
          permiss: '查看',
          level: 2,
          checked: false,
        }, {
          id: 1.4,
          categor: '单品全渠道',
          permiss: '查看',
          level: 2,
          checked: false,
        }]
      }, {
        id: 2,
        categor: '利润',
        permiss: '默认可查看',
        level: 1,
        checked: false,
        children: [{
          id: 2.1,
          categor: '利润日报',
          permiss: '查看',
          level: 2,
          checked: false,
        }, {
          id: 2.2,
          categor: '渠道财务报表',
          permiss: '查看',
          level: 2,
          checked: false,
        }, {
          id: 2.3,
          categor: '店铺财务报表',
          permiss: '查看',
          level: 2,
          checked: false,
        }]
      }],

      disabledState: false,

      dialoguserVisible: false,
      userchecked: false,
      userList: [{
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)1',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)2',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)3',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)4',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)5',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)6',
      }, {
        checked: false,
        title: '淘宝_zhengfy户外(zhengfy户外:2218822347272)7',
      }],
      settleList: [],

      rolesObj: {
        id: '',
        roles: '',
        desc: '',
        routes: '',
      },
      // 核心：永久关闭原生联动
      checkStrictly: true,
      routes: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      dialogType: 'new',
      treeInitFlag: false, // 标记树是否已初始化
    }
  },

  computed: {
    routesData() {
      return this.routes
    }
  },

  created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;

    this.ManagerRolesFun()
    this.getindexUserFun()
    this.getManagerAllMenuFun()

  },

  methods: {
    // 弹窗打开前的钩子，重置树初始化状态
    beforeDialogOpen() {
      this.treeInitFlag = false;
      // 确保树数据已加载完成
      if (this.routesData.length === 0) {
        this.getManagerAllMenuFun().then(() => {
          this.treeInitFlag = true;
        });
      } else {
        this.treeInitFlag = true;
      }
    },

    // 核心：手动实现父子联动逻辑（替代原生联动）
    handleTreeCheck(node, checkedInfo) {
      const treeRef = this.$refs.tree;
      if (!treeRef || !node.children || node.children.length === 0) return;

      // 获取当前节点的勾选状态
      const isChecked = checkedInfo.checkedKeys.includes(node.id);
      // 收集所有子节点ID
      const childIds = this.getAllChildNodeIds(node.children);

      // 勾选父节点 → 选中所有子节点；取消父节点 → 取消所有子节点
      if (isChecked) {
        treeRef.setCheckedNodes([...treeRef.getCheckedNodes(), ...childIds.map(id => ({id}))]);
      } else {
        childIds.forEach(id => {
          treeRef.setChecked(id, false);
        });
      }
    },

    // 递归收集所有子节点ID（用于手动联动）
    getAllChildNodeIds(nodes) {
      let ids = [];
      nodes.forEach(node => {
        ids.push(node.id);
        if (node.children && node.children.length > 0) {
          ids = [...ids, ...this.getAllChildNodeIds(node.children)];
        }
      });
      return ids;
    },

    allchecked(){
      console.log(this.userchecked, '000000')
      for (let item of this.userList) {
        if (this.userchecked) {
          item.checked = true;
        }
        if (!this.userchecked) {
          item.checked = false;
        }
      }
      this.allselect()
    },
    checkedClick(){
      this.allselect()
    },

    //查看全选
    allselect() {
      this.settleList = []
      const dataList = this.userList
      if (dataList.length === 0) return
      let child_boolen = []
      for (let item of dataList) {
        child_boolen.push(item.checked)
      }
      if (/false/.test(child_boolen)) {
        this.userchecked = false
      } else {
        this.userchecked = true
      }
      for (let item of this.userList) {
        if (item.checked) {
          this.settleList.push(item)
        }
      }
    },

    personClick(index){
      if(Number(this.personIndex) === Number(index)) return
      this.personIndex = index
      this.getMenuByrolesFun()
    },

    handleClick(row){
      if(this.activeName === row.activeVal) return
      this.activeName = row.activeVal
      if(row.activeVal === 'partper'){
        this.getindexUserFun()
      }
      if(row.activeVal === 'journa'){
        this.disabledState = false
        this.getMenuByrolesFun()
      }
    },

    activeFun(){
      this.dataList = []
      if(this.activeName === 'partper'){
        this.dataList = JSON.parse(JSON.stringify(this.partperList))
      }
      if(this.activeName === 'journa'){
        this.dataList = JSON.parse(JSON.stringify(this.journaList))
      }
      if(this.activeName === 'ability'){
        this.dataList = JSON.parse(JSON.stringify(this.pduoduoList))
      }
    },

    async ManagerRolesFun(){
      const res = await this.$http.get(this.$urls.ManagerRoles);
      console.log(res.data, '11111111111')
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.personList = res.data
    },

    async getindexUserFun(){
      const res = await this.$http.get(this.$urls.getindexUserList, this.listQuery);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.total = res.data.count
      this.partperList = res.data.list
      this.activeFun()
    },

    async getMenuByrolesFun(){
      const res = await this.$http.get(this.$urls.getMenuByroles, {
        roles: this.personList[this.personIndex].id
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      console.log(res, '101001')
      if(res.data.menu.length > 0){
        let array = res.data.menu
        for(let item of array){
          if(Number(item.pid) === 0){
            item.permiss = '默认可查看'
          }
          if(item.children && item.children.length > 0){
            for(let child of item.children){
              child.permiss = '查看'
            }
          }
        }
        this.journaList = array
      } else {
        this.journaList = []
      }
      this.$nextTick(() =>{
        this.activeFun()
      })
    },

    importClose(){
      Object.keys(this.rolesObj).forEach(key =>{
        this.rolesObj[key] = ""
      })
    },

    exportExcel(type, row){
      if(type === 'add'){
        this.dialogType = 'new';
        this.dialogimportVisible = true;
        // 清空勾选
        this.$nextTick(() => {
          const treeRef = this.$refs.tree;
          if (treeRef && treeRef.$el) {
            try {
              treeRef.setCheckedNodes([]);
            } catch (e) {
              console.warn('清空树勾选失败：', e);
            }
          }
        });
      }
      if(type === 'edit'){
        let rolesObj = Object.assign({}, row)
        this.dialogType = 'edit'
        this.dialogimportVisible = true
        this.$set(this.rolesObj, 'id', rolesObj.id)
        this.$set(this.rolesObj, 'roles', rolesObj.roles)
        this.$set(this.rolesObj, 'desc', rolesObj.desc)
        var checked = rolesObj.routes.split(",");
        var arr = [];
        // 仅生成服务器返回的ID数组（精准回显）
        for(var i = 0; i < checked.length; i ++) {
          arr.push({id: checked[i]})
        }
        // 精准回显（无原生联动，不会自动选子元素）
        this.$nextTick(() => {
          setTimeout(() => {
            const treeRef = this.$refs.tree;
            if (treeRef && treeRef.$el) { 
              try {
                treeRef.setCheckedNodes([]); // 清空
                treeRef.setCheckedNodes(arr); // 仅设置服务器返回的ID
              } catch (e) {
                console.warn('设置树勾选失败：', e);
              }
            }
          }, 50);
        });
      }
      if(type === 'del'){
        this.$confirm("确定删除?", "警告！", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          const res = await this.$http.get(this.$urls.deleteManagerRoles, {id: row.id});
          if (res.errcode == 0) {
            DonMessage.success("操作成功");
            this.ManagerRolesFun()
          } else {
            DonMessage.error("操作失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },

    // 递归查找子节点的所有父节点ID
    findParentIdsById(treeData, targetId, parentIds = [], currentParentId = null) {
      const targetIdStr = String(targetId);
      
      for (let node of treeData) {
        const nodeIdStr = String(node.id);

        if (nodeIdStr === targetIdStr) {
          return parentIds;
        }

        if (node.children && node.children.length > 0) {
          const newParentIds = [...parentIds, node.id];
          const result = this.findParentIdsById(node.children, targetId, newParentIds, node.id);
          if (result.length > 0) {
            return result;
          }
        }
      }
      return [];
    },

    // 提交逻辑（仍自动补全父ID）
    async confirmRole() {
      const treeRef = this.$refs.tree;
      if (!treeRef || !treeRef.$el) {
        console.error('el-tree DOM无效');
        DonMessage.error('菜单选择组件加载失败，请关闭弹窗重试');
        return;
      }

      // 安全获取勾选节点
      let leafCheckedNodes = [];
      let allCheckedNodes = [];
      try {
        leafCheckedNodes = treeRef.getCheckedNodes(true);
        allCheckedNodes = treeRef.getCheckedNodes(false);
      } catch (e) {
        console.error('获取树勾选节点失败：', e);
        DonMessage.error('获取选择的菜单失败，请重试');
        return;
      }

      // 收集ID（子节点+父节点）
      let allIds = [];
      leafCheckedNodes.forEach(node => {
        if (node.id) {
          allIds.push(node.id);
          const parentIds = this.findParentIdsById(this.routesData, node.id);
          allIds = [...allIds, ...parentIds];
        }
      });

      allCheckedNodes.forEach(node => {
        if (node.id && (!node.children || node.children.length === 0)) return;
        allIds.push(node.id);
      });

      // 去重+统一类型
      const uniqueIds = [...new Set(allIds)].map(id => String(id));
      console.log('最终提交ID：', uniqueIds);
      
      var data = this.rolesObj;
      data.routes = uniqueIds;

      // 保留测试用return
      // return

      // 提交逻辑
      if (this.dialogType === 'edit') {
        const res = await this.$http.post(this.$urls.editManagerRoles, {...data, desc: data.roles});
        if(res.errcode == 0){
          this.$message({ type: 'success', message: '编辑成功' })
          this.dialogimportVisible = false;
          this.ManagerRolesFun();
        }else{
          this.$message({ type: 'error', message: '编辑失败' })
        }
      } else {
        if(data.roles == '') return this.$message({ message: '请输入分组名称', type: 'warning' });
        if(data.routes.length == 0) return this.$message({ message: '请选择系统菜单', type: 'warning' });
        const res = await this.$http.post(this.$urls.addManagerRoles, {...data, desc: data.roles});
        if(res.errcode == 0) {
          DonMessage.success("添加成功");
          this.dialogimportVisible = false;
          this.ManagerRolesFun();
        } else {
          DonMessage.error(res.errmsg);
        }
      }
    },

    async getManagerAllMenuFun(){
      try {
        const res = await this.$http.post(this.$urls.getManagerAllMenu, {})
        console.log(res.menu, '10000')
        this.routes = this.generateRoutes(res.menu)
        this.treeInitFlag = true;
        return this.routes;
      } catch (e) {
        console.error('加载菜单数据失败：', e);
        DonMessage.error('菜单数据加载失败，请重试');
        return [];
      }
    },

    generateRoutes(routes, basePath = '/') {
      const res = []

      for (let route of routes) {
        if (route.hidden) { continue }

        const onlyOneShowingChild = this.onlyOneShowingChild(route.children, route)

        if (route.children && onlyOneShowingChild && !route.alwaysShow) {
          route = onlyOneShowingChild
        }

        const data = {
          id: route.id,
          path: path.resolve(basePath, route.path),
          title: route.meta && route.meta.title
        }

        if (route.children) {
          data.children = this.generateRoutes(route.children, data.path)
        }
        res.push(data)
      }
      return res
    },

    onlyOneShowingChild(children = [], parent) {
      let onlyOneChild = null
      const showingChildren = children.filter(item => !item.hidden)

      if (showingChildren.length === 1) {
        onlyOneChild = showingChildren[0]
        onlyOneChild.path = path.resolve(parent.path, onlyOneChild.path)
        return onlyOneChild
      }

      if (showingChildren.length === 0) {
        onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return onlyOneChild
      }

      return false
    }

  }
}
</script>

<style lang="scss" scoped>
  .rolement{
    padding: 0px 16px;
  }
  .rolement-person{
    height: auto;
    background: #F5F5F5;
    border-radius: 10px;
    padding: 20px 8px;
    margin-right: 13px;
    .rolement-person-inp{
      width: 322px;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      padding: 0 11px;
      .top_bar_inp_img1 {
        width: 24px;
        height: 24px;
        margin-right: 12px;
        cursor: pointer;
      }
      input {
        font-size: 17px;
        line-height: 17px;
      }
    }
    .rolement-person-data{
      width: 100%;
      height: 70vh;
      overflow-y: scroll;
      margin: 20px 0px;
      .rolement-person-data-boxs{
        width: 100%;
        padding: 6px 12px;
        margin-bottom: 14px;
        border-radius: 10px;
        cursor: pointer;
        img{
          width: 22px;
          height: 22px;
        }
        p{
          font-size: 18px;
          line-height: 18px;
          margin: 0px 12px;
        }
      }
      .active{
        background: rgba(231, 235, 247, 1);
      }
    }

    .rolement-person-but{
      width: 225px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      background: rgba(25, 92, 248, 1);
      border-radius: 10px;
      font-size: 20px;
      cursor: pointer;
    }
  }


  .rolement-right{
    .plateorder-tabs{
      padding: 9px 18px 8px 47px;
      margin-bottom: 28px;
    .plateorder-tabs-boxs{
      gap: 68px;
      li{
       p{
        font-size: 26px;
       }
       div{
        width: 100%;
        height: 3px;
        background: rgba(25, 92, 248, 1);
        border-radius: 2px;
        bottom: -12px;
        left: 0px;
       }
      }
      .active{
        color: rgba(25, 92, 248, 1);
      }
      .activenot{
        color: rgba(35, 35, 35, 1);
      }
    }
    .plateorder-tabs-input-but{
      width: 131px; height: 54px;
      background: rgba(25, 92, 248, 1);
      border-radius: 10px; font-size: 20px; line-height: 54px; text-align: center;
      cursor: pointer;
    }
  }

  }


  .import-mask{
    width: 100%;
    border-radius: 15px;
    background-image: url('../../../../../assets/yimou/tb.png');
    background-size: 100% 51px;
    background-repeat: no-repeat;
    padding-bottom: 40px;
    .import-mask-title{
      width: 100%;
      height: 51px;
      line-height: 51px;
      text-align: center;
      font-size: 18px;
      img{
        width: 13px;
        height: 13px;
        top: 21px;
        right: 20px;
        cursor: pointer;
      }
    }
    .import-mask-boxs{
      width: 650px;
      margin-top: 40px;
      .import-mask-boxs-inp{
        width: 100%;
        background: rgba(245, 245, 245, 1); border-radius: 10px; padding: 11px 22px;
        margin-bottom: 19px;
        ul{
          li:nth-of-type(1){
            width: 185px;
            font-size: 18px;
            line-height: 18px;
            span{
              color: rgba(255, 0, 0, 1);
            }
          }
        }
      }
      .import-mask-boxs-inp .el-input /deep/.el-input__inner {
        border: none !important;
        background: none !important;
        font-size: 18px;
      }
      .import-mask-boxs-inp .el-textarea /deep/.el-textarea__inner{
        border: none !important;
        background: none !important;
        font-size: 18px;
      }

      .import-mask-ul-boxs{
        width: 24vw;
      }
    }
    .import-mask-but{
      width: 266px;
      height: 47px;
      line-height: 47px;
      text-align: center;
      background: rgba(25, 92, 248, 1);
      border-radius: 10px;
      font-size: 17px;
      cursor: pointer;
    }
  }

  .statusact{
    width: 13px;
    height: 13px;
    background: rgba(48, 255, 0, 1);
    border-radius: 50%;
    margin-right: 12px;
  }
  .statusactnot{
    width: 13px;
    height: 13px;
    background: red;
    border-radius: 50%;
    margin-right: 12px;
  }

  .reset-btn{
    font-size: 30px;
  }

  .rolement-title{
    margin-bottom: 26px;
    img{
      width: 21px; height: 21px; margin-right: 10px;
    }
    p{
      font-size: 18px;
      line-height: 18px;
    }
  }


  .journa-ability{
    .el-table /deep/.cell{
      display: flex;
      align-items: center;
      padding-left: 40%;
    }
  }

  .import-maskuser{
    .rolement-person-inp{
        width: 100%;
        height: 50px;
        background: rgba(245, 245, 245, 1);
        border-radius: 10px;
        padding: 0 11px;
        .top_bar_inp_img1 {
          width: 24px;
          height: 24px;
          margin-right: 12px;
          cursor: pointer;
        }
        input {
          font-size: 17px;
          line-height: 17px;
        }
      }
      .import-maskuser-boxs{
        padding: 20px 29px 0px;
        .import-maskuser-boxs-div{
          width: 48%;
          .import-maskuser-boxs-div-title{
            font-size: 24px; line-height: 24px; margin: 29px 0px 23px
          }
          .import-maskuser-boxs-div-scroll{
            height: 190px; padding-bottom: 20px; overflow-y: scroll; scrollbar-width: none; /* Firefox */  -ms-overflow-style: none; /* IE 和 Edge */
          }
          .import-maskuser-boxs-div-user{
            padding: 16px 0px;
            p{
              font-size: 18px; line-height: 18px;margin-left: 16px
            }
          }

          .import-maskuser-boxs-div-content{
            p{
              font-size: 18px; line-height: 18px;
            }
            p:nth-of-type(2){
              color: rgba(25, 92, 248, 1);
            }
          }
          .import-maskuser-boxs-right-scroll{
            height: 260px; margin: 20px 0px; overflow-y: scroll; scrollbar-width: none; /* Firefox */  -ms-overflow-style: none;
          }
        }
        .import-maskuser-boxs-but{
          width: 115px; height: 47px; line-height: 47px; font-size: 17px; text-align: center; background: rgba(25, 92, 248, 1); border-radius: 10px;
        }

        .import-maskuser-boxs-solid{
          width: 1px; height: 366px; background: rgba(0, 0, 0, 0.1);
        }


      }

    }

  .permission-tree {
    margin-bottom: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/main/level1/power_ment/rolement/index.vue